
import { Component, Vue, Watch } from 'vue-property-decorator';
import { PermissionTypeEnum } from './libs/Api';
import { authStore } from './libs/auth/+store/store';
import { AuthGetter } from './libs/auth/models/auth-state';
import { CreateCrudStoreResult } from './libs/core/+state/models/create-crud-store-result';
import { CrudReponse, CrudResponseAction } from './libs/core/+state/models/crud-action';
import moment from 'moment/moment';
import { GlobalVariables } from '@/libs/core/global';

type Dictionary<T> = { [key: string]: T };

@Component({
    components: {},
})
export default class Page extends Vue {
    private query: Dictionary<string | (string | null)[]> = {};
    private params: Dictionary<string | (string | null)[]> = {};

    protected get BlobStorage(): string {
        return (window as any).BlobStorage ?? 'https://idominoams.blob.core.windows.net/ams-public';
    }

    public subscribe(store: CreateCrudStoreResult<any>, action: CrudReponse, key: string | null = null): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            const subscription = this.$store.subscribe((mutation) => {
                let payloadKey = mutation.payload.key;
                if (!payloadKey) {
                    payloadKey = '';
                }
                if (!key) {
                    key = '';
                }
                if (payloadKey != key) {
                    return;
                }
                switch (action) {
                    case CrudReponse.GetAll:
                        if (mutation.type === store.getActionName(CrudResponseAction.GetAllSuccess)) {
                            resolve(mutation.payload.data);
                            subscription();
                        } else if (mutation.type === store.getActionName(CrudResponseAction.GetAllNoop)) {
                            resolve(mutation.payload.data);
                            subscription();
                        } else if (mutation.type === store.getActionName(CrudResponseAction.GetAllFailed)) {
                            reject(mutation.payload);
                            subscription();
                        }
                        break;
                    case CrudReponse.GetAllBasic:
                        if (mutation.type === store.getActionName(CrudResponseAction.GetAllBasicSuccess)) {
                            resolve(mutation.payload.data);
                            subscription();
                        } else if (mutation.type === store.getActionName(CrudResponseAction.GetAllBasicNoop)) {
                            resolve(mutation.payload.data);
                            subscription();
                        } else if (mutation.type === store.getActionName(CrudResponseAction.GetAllBasicFailed)) {
                            reject(mutation.payload);
                            subscription();
                        }
                        break;
                    case CrudReponse.Get:
                        if (mutation.type === store.getActionName(CrudResponseAction.GetSuccess)) {
                            resolve(mutation.payload.item);
                            subscription();
                        } else if (mutation.type === store.getActionName(CrudResponseAction.GetFailed)) {
                            reject(mutation.payload);
                            subscription();
                        }
                        break;
                    case CrudReponse.Create:
                        if (mutation.type === store.getActionName(CrudResponseAction.CreateSuccess)) {
                            resolve(mutation.payload.item);
                            subscription();
                        } else if (mutation.type === store.getActionName(CrudResponseAction.CreateFailed)) {
                            reject(mutation.payload);
                            subscription();
                        }
                        break;
                    case CrudReponse.Clone:
                        if (mutation.type === store.getActionName(CrudResponseAction.CloneSuccess)) {
                            resolve(mutation.payload.item);
                            subscription();
                        } else if (mutation.type === store.getActionName(CrudResponseAction.CloneFailed)) {
                            reject(mutation.payload);
                            subscription();
                        }
                        break;
                    case CrudReponse.Update:
                        if (mutation.type === store.getActionName(CrudResponseAction.UpdateSuccess)) {
                            resolve(mutation.payload.item);
                            subscription();
                        } else if (mutation.type === store.getActionName(CrudResponseAction.UpdateFailed)) {
                            reject(mutation.payload);
                            subscription();
                        }
                        break;
                    case CrudReponse.PartialUpdate:
                        if (mutation.type === store.getActionName(CrudResponseAction.PartialUpdateSuccess)) {
                            resolve(mutation.payload.item);
                            subscription();
                        } else if (mutation.type === store.getActionName(CrudResponseAction.PartialUpdateFailed)) {
                            reject(mutation.payload);
                            subscription();
                        }
                        break;
                    case CrudReponse.BatchPartial:
                        if (mutation.type === store.getActionName(CrudResponseAction.BatchPartialUpdateSuccess)) {
                            resolve(mutation.payload.item);
                            subscription();
                        } else if (mutation.type === store.getActionName(CrudResponseAction.BatchPartialUpdateFailed)) {
                            reject(mutation.payload);
                            subscription();
                        }
                        break;
                    case CrudReponse.Delete:
                        if (mutation.type === store.getActionName(CrudResponseAction.DeleteSuccess)) {
                            resolve(mutation.payload.data);
                            subscription();
                        } else if (mutation.type === store.getActionName(CrudResponseAction.DeleteFailed)) {
                            reject(mutation.payload);
                            subscription();
                        }
                        break;
                    case CrudReponse.Download:
                        if (mutation.type === store.getActionName(CrudResponseAction.DownloadSuccess)) {
                            resolve(mutation.payload.data);
                            subscription();
                        } else if (mutation.type === store.getActionName(CrudResponseAction.DownloadFailed)) {
                            reject(mutation.payload);
                            subscription();
                        }
                        break;
                }
            });
        });
    }

    public setQuery(
        q: string,
        v: string | null,
        localStorage = false,
        localStoragePrefix = 'Q',
        localStorageExpiration: Date | null = null
    ) {
        if (v == null || v.length == 0 || v == 'null') {
            if (this.query[q]) {
                delete this.query[q];
            }
        } else {
            this.query[q] = v.toString();
        }
        if (localStorage) {
            if (v) {
                window.localStorage.setItem(`${localStoragePrefix}:${q}`, v);
                if (localStorageExpiration) {
                    window.localStorage.setItem(
                        `${localStoragePrefix}:${q}:EXPIRATION`,
                        localStorageExpiration.getTime().toString()
                    );
                }
            } else {
                window.localStorage.removeItem(`${localStoragePrefix}:${q}`);
                window.localStorage.removeItem(`${localStoragePrefix}:${q}:EXPIRATION`);
            }
        }
        this.replaceRoute();
    }

    public getQuery(q: string, localStorage = false, localStoragePrefix = 'Q'): string | null {
        const currentRoute = this.$router.currentRoute;
        if (currentRoute.query[q] && currentRoute.query[q]?.toString().length > 0) {
            return currentRoute.query[q].toString();
        }
        if (localStorage && window.localStorage.getItem(`${localStoragePrefix}:${q}`)) {
            if (
                window.localStorage.getItem(`${localStoragePrefix}:${q}:EXPIRATION`) &&
                new Date().getTime() > Number(window.localStorage.getItem(`${localStoragePrefix}:${q}:EXPIRATION`))
            ) {
                window.localStorage.removeItem(`${localStoragePrefix}:${q}`);
                window.localStorage.removeItem(`${localStoragePrefix}:${q}:EXPIRATION`);
                return null;
            }
            return window.localStorage.getItem(`${localStoragePrefix}:${q}`);
        }
        return null;
    }

    public getQueryInt(q: string, localStorage = false, localStoragePrefix = 'Q'): number | null {
        const v = this.getQuery(q, localStorage, localStoragePrefix);
        if (v && !isNaN(Number(v))) {
            return Number(v);
        }
        return null;
    }

    public hasPermissions(permissionTypes: PermissionTypeEnum[]): boolean {
        if (!permissionTypes) return true;
        const permissions = authStore.useGetter(AuthGetter.GetPermissions) as PermissionTypeEnum[];
        return permissions.any((x) => permissionTypes.any((p) => p == x));
    }

    public hasAnyPermissions(): boolean {
        const permissions = (authStore.useGetter(AuthGetter.GetPermissions) as PermissionTypeEnum[]) ?? [];
        return permissions.length > 0;
    }

    public textAreaToHtml(value: string | null, length = 0): string | null {
        if (value) {
            value = value.replaceAll('\n', '<br />');
        }
        if (value) {
            if (length > 0) {
                if (value.length > length) {
                    value = value.substring(0, length).concat('...');
                }
            }
        }
        return value;
    }

    public useWhiteFont(color: string | null | undefined): boolean {
        if (!color) return true; // Default to white font if color is null or undefined

        // Remove the '#' if present and ensure the color string is valid
        const hex = color.replace('#', '');
        if (hex.length !== 6) return true; // Default to white font if the color format is incorrect

        // Parse the hex color to RGB values
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);

        // Calculate the luminance
        const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

        // Return true for white font if luminance is lower than the threshold (0.5)
        return luminance < 0.6;
    }

    public formatSimpleDate(value: string): string {
        if (value) {
            return moment(String(value)).locale(GlobalVariables.lang).format('DD.MM.YYYY');
        }
        return '';
    }

    public formatDate(value: string): string {
        if (value) {
            return moment(String(value)).locale(GlobalVariables.lang).format('DD.MM.YYYY HH:mm');
        }
        return '';
    }

    @Watch('$route')
    public routeChanged() {
        this.query = this.$router.currentRoute.query;
        this.params = this.$router.currentRoute.params;
    }

    public mounted() {
        this.query = this.$router.currentRoute.query;
        this.params = this.$router.currentRoute.params;
    }

    private replaceRoute() {
        const value: Dictionary<string | (string | null)[]> = {};
        const keys = Object.keys(this.query);
        keys.forEach((k) => {
            if (this.query[k] && this.query[k]?.length > 0) {
                value[k] = this.query[k].toString();
            }
        });
        value['t'] = new Date().getTime().toString();
        this.$router.replace({
            name: this.$router.currentRoute.name!,
            params: this.$router.currentRoute.params,
            query: value,
        });
    }
}
